import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=2727478a"
import script from "./SignUpPage.vue?vue&type=script&lang=js"
export * from "./SignUpPage.vue?vue&type=script&lang=js"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=2727478a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports